module.exports = __webpack_public_path__ + "static/ofcar12-a3f59d7d695523d583dee2b7d05946ac.jpg";